<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <el-descriptions>
        <el-descriptions-item label="售后编码">{{form.orderNum}}</el-descriptions-item>
        <el-descriptions-item label="下单人">{{form.applyName}}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{form.applyPho}}</el-descriptions-item>
        <el-descriptions-item label="所属区域" v-if="form.addr && form.addr.length > 0">
          <span v-for="(item,index) in form.addr" :key="index">{{item.regionName}}</span>
        </el-descriptions-item>
        <el-descriptions-item label="快递单号">{{form.deliverInfo}}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{form.applyTime}}</el-descriptions-item>
        <el-descriptions-item label="操作时间">{{form.operatePO && form.operatePO.operatedTime}}</el-descriptions-item>
        <el-descriptions-item label="操作人">{{form.operatePO && form.operatePO.realName}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">售后商品信息</span></div>
      <el-descriptions :column="2">
        <el-descriptions-item label="收货员">{{form.signedByName}}</el-descriptions-item>
        <el-descriptions-item label="确认收货时间">{{form.signedTime}}</el-descriptions-item>
        <el-descriptions-item label="实际收货商品"></el-descriptions-item>
      </el-descriptions>
      <el-table :data="form.goodsList" style="width: 100%">
        <el-table-column prop="afterGoodsName" label="商品名称" align="center" ></el-table-column>
        <el-table-column prop="afterGoodsCount" label="件数" align="center"> </el-table-column>
        <el-table-column prop="platformProductName" label="平台匹配商品" align="center"> </el-table-column>
        <el-table-column prop="acceptanceQuantity" label="验收数量" align="center"> </el-table-column>
        <el-table-column prop="retailPrice" label="零售价" align="center"> </el-table-column>
        <el-table-column prop="batchNumber" label="批次号" align="center"> </el-table-column>
        <el-table-column prop="inBoundQuantity" label="入库信息" align="center"> </el-table-column>
        <el-table-column prop="expirationDate" label="有效期" align="center"> </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import goodsOrderApi from '@/api/order/goodsOrder'
export default {
  props: ['rowItem'],
  data() {
    return {
      activeName: 1,
      tabType: 1,  //1基础信息 0 物流信息
      tableData: [],
      form: '',
    };
  },
  created() {
    this.getDetails()
  },
  methods: {
    getDetails() {
      goodsOrderApi.getAfterDetail(this.rowItem.id).then(({ data }) => {
        this.form = data;
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  },
};
</script>
<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin: 20px 0;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.title-cont {
  padding: 10px 20px;
  .fr3 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr3-body {
      width: 33.33%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
  .fr1 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .fr1-body {
      width: 100%;
      font-size: 14px;
      color: #2e2f3e;
      line-height: 30px;
    }
  }
}
.blueColor {
  color: #1596cd !important;
}
.banner-box {
  width: 50px;
  height: 50px;
  margin: 2px;
}
</style>
